import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store/admin.js";

import ServiceList from "../views/admin/ServiceList.vue";
import ServiceForm from "../views/admin/ServiceForm.vue";
import ServiceBookings from "../views/admin/ServiceBookings.vue";
import SettingGeneral from "../views/admin/SettingGeneral.vue";
import SettingProfile from "../views/admin/SettingProfile.vue";
import SettingCalendars from "../views/admin/SettingCalendars.vue";
import SettingIntegrations from "../views/admin/SettingIntegrations.vue";
import SettingAdmins from "../views/admin/SettingAdmins.vue";
import SettingAccount from "../views/admin/SettingAccount.vue";
import SettingAccountSignupLogin from "../components/admin/SettingAccountSignupLogin.vue";
import MiscNonAdmin from "../views/admin/MiscNonAdmin.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    //name: "home",
    redirect: "/bookings"
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import("../views/About.vue")
  // },
  {
    path: "/event-types",
    name: "service_list",
    component: ServiceList
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-ServiceList" */ "../views/admin/ServiceList.vue"
    //   )
  },
  {
    path: "/event-type/add",
    name: "service_add",
    component: ServiceForm
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-ServiceForm" */ "../views/admin/ServiceForm.vue"
    //   )
  },
  {
    path: "/event-type/edit/:service_id",
    name: "service_edit",
    component: ServiceForm
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-ServiceForm" */ "../views/admin/ServiceForm.vue"
    //   )
  },
  {
    path: "/bookings",
    name: "booking_list",
    children: [
      {
        path: "/bookings/custom/:booking_id/",
        name: "booking_custom_by_id"
      }
    ],
    component: ServiceBookings
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-ServiceBookings" */ "../views/admin/ServiceBookings.vue"
    //   )
  },
  {
    path: "/settings",
    name: "setting_general",
    component: SettingGeneral
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../views/admin/SettingGeneral.vue"
    //   )
  },
  {
    path: "/settings/profile",
    name: "setting_profile",
    component: SettingProfile
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../views/admin/SettingProfile.vue"
    //   )
  },
  {
    path: "/settings/calendars",
    name: "setting_calendars",
    component: SettingCalendars,
    props: true,
    children: [
      {
        path: "/settings/calendars/connected/:calendar_account_id/",
        redirect: to => ({
          name: "setting_calendars",
          params: {
            connect_status: "connected",
            connected_calendar_account_id: to.params.calendar_account_id
          }
        })
      },
      {
        path:
          "/settings/calendars/connected/:calendar_account_id/default_calendars_added",
        redirect: to => ({
          name: "setting_calendars",
          params: {
            connect_status: "connected",
            connected_calendar_account_id: to.params.calendar_account_id,
            connected_calendar_default_calendars_added: true
          }
        })
      }
    ]
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../views/admin/SettingCalendars.vue"
    //   )
  },
  {
    path: "/settings/integrations",
    name: "setting_integrations",
    component: SettingIntegrations,
    props: true,
    children: [
      {
        path: "/settings/integrations/connected/:tp_account_id/",
        redirect: to => ({
          name: "setting_integrations",
          params: {
            connect_status: "connected",
            connected_tp_account_id: to.params.tp_account_id
          }
        })
      }
    ]
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../views/admin/SettingIntegrations.vue"
    //   )
  },
  {
    path: "/settings/admins",
    name: "setting_admins",
    component: SettingAdmins
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../views/admin/SettingAdmins.vue"
    //   )
  },
  {
    path: "/settings/account",
    name: "setting_account",
    component: SettingAccount
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../views/admin/SettingAccount.vue"
    //   )
  },
  {
    path: "/settings/account/login",
    name: "setting_account_login",
    component: SettingAccountSignupLogin,
    props: true
    // component: () =>
    //   import(
    //     /* webpackChunkName: "admin-Settings" */ "../components/admin/SettingAccountSignupLogin.vue"
    //   )
  },
  {
    path: "/non_wpcal_admin",
    name: "misc_non_wpcal_admin",
    component: MiscNonAdmin
  }
];

const router = new VueRouter({
  //mode: "history",
  //base: process.env.BASE_URL,
  routes
});

const hightlight_wp_admin_menu = to => {
  let sub_menu_conts = document.querySelectorAll(
    "#toplevel_page_wpcal_admin .wp-submenu li"
  );
  let main_path = to.path.split("/")[1];
  const hightlight_menu = {
    "event-types": ["event-types", "event-type"],
    bookings: ["bookings"],
    settings: ["settings"]
  };
  if (to.path)
    for (let sub_menu_cont of sub_menu_conts) {
      if (sub_menu_cont.classList.contains("wp-submenu-head")) {
        continue;
      }
      sub_menu_cont.classList.remove("current");
      let sub_menu_link = sub_menu_cont.querySelector("a");
      sub_menu_link.classList.remove("current");
      let href_main_path = sub_menu_link
        .getAttribute("href")
        ?.split("#")[1]
        ?.split("/")[1];
      if (
        href_main_path &&
        hightlight_menu?.[href_main_path] &&
        hightlight_menu[href_main_path].indexOf(main_path) > -1
      ) {
        sub_menu_cont.classList.add("current");
        sub_menu_link.classList.add("current");
      }
    }
};

//loading indicator for lazy loading the components in admin end
router.beforeEach((to, from, next) => {
  let client_end = "admin";
  document
    .getElementById("wpcal_" + client_end + "_app")
    .classList.add("loading-indicator");
  next();
});
router.afterEach((to, from) => {
  let update_document_title = () => {
    setTimeout(async () => {
      let instances = await to.matched[0]?.instances;
      let document_title = instances?.default?.document_title_final
        ? instances.default.document_title_final
        : "";
      store.dispatch("set_document_title", document_title);
    }, 50);
  };
  update_document_title();
  hightlight_wp_admin_menu(to);

  let client_end = "admin";
  document
    .getElementById("wpcal_" + client_end + "_app")
    .classList.remove("loading-indicator");
});

export default router;
